import { Badge } from '@mantine/core';
import {
  IconCheck,
  IconClock,
  IconAlertCircle,
  IconLoader,
  IconTrash,
} from '@tabler/icons-react';

interface EnvironmentStatusBadgeProps {
  status: string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}

export function EnvironmentStatusBadge({ status, size = 'sm' }: EnvironmentStatusBadgeProps) {
  const statusConfig = {
    ready: {
      color: 'green',
      icon: <IconCheck size={14} />,
      label: 'Ready',
    },
    pending: {
      color: 'blue',
      icon: <IconClock size={14} />,
      label: 'Pending',
    },
    creating: {
      color: 'yellow',
      icon: <IconLoader size={14} />,
      label: 'Creating',
    },
    failed: {
      color: 'red',
      icon: <IconAlertCircle size={14} />,
      label: 'Failed',
    },
    deleting: {
      color: 'orange',
      icon: <IconTrash size={14} />,
      label: 'Deleting',
    },
    deleted: {
      color: 'gray',
      icon: <IconTrash size={14} />,
      label: 'Deleted',
    },
  };

  const config = statusConfig[status as keyof typeof statusConfig] || {
    color: 'gray',
    icon: <IconClock size={14} />,
    label: status,
  };

  return (
    <Badge
      color={config.color}
      variant="light"
      leftSection={config.icon}
      size={size}
    >
      {config.label}
    </Badge>
  );
}

